document.addEventListener('click', function (e) {
  const img = e.target.closest('.size-chart img');
  if (!img) return;

  const overlay = document.createElement('div');
  overlay.className = 'size-chart-zoom-overlay';

  const zoomImg = document.createElement('img');
  zoomImg.src = img.src;

  overlay.appendChild(zoomImg);
  document.body.appendChild(overlay);

  overlay.addEventListener('click', () => {
    overlay.remove();
  });
});


const applyShadowStyles = () => {
  const tabbyHost = document.querySelector('#TabbyPromo');
  if (!tabbyHost || !tabbyHost.shadowRoot) return;

  const shadow = tabbyHost.shadowRoot;

  const svg = shadow.querySelector('svg');
  if (!svg || svg.dataset.styled) return;

  const paths = svg.querySelectorAll('path');

  paths.forEach((path, index) => {
    path.style.fill = index === 0 ? '#000' : '#fff';
  });

  svg.dataset.styled = 'true';
};